import React, { useState, useEffect } from 'react';
import { Lock, Clock } from 'lucide-react';
import { formatDateTime } from '../../../utils/formatDate';
import styles from './form.module.css';

const PredictionForm = ({ content, onSubmit, isPreview = false, isLocked = false, userAnswer = null, allowUpdateResponse = true }) => {
    const options = content?.options || [];
    const deadline = content?.settings?.predictionDeadline;

    const [selected, setSelected] = useState(() => userAnswer?.prediction || null);

    useEffect(() => {
        setSelected(userAnswer?.prediction || null);
    }, [userAnswer]);

    const hasSubmitted = userAnswer != null;
    const isDisabled = isLocked || (hasSubmitted && !allowUpdateResponse);
    const isUnchanged = hasSubmitted && selected === userAnswer.prediction;
    const submitDisabled = isPreview || isLocked || !selected || (hasSubmitted && (!allowUpdateResponse || isUnchanged));
    const submitLabel = !hasSubmitted ? (isLocked ? 'Voting Closed' : 'Submit Prediction') : (!allowUpdateResponse || isUnchanged ? 'Submitted ✓' : 'Update prediction');

    const handleSubmit = () => {
        if (submitDisabled) return;
        onSubmit({ prediction: selected });
    };

    return (
        <div className={styles.form}>
            <div className={styles.question}>
                {content.question || 'What is your prediction?'}
                {isLocked && <span className={styles.lockBadge}><Lock size={12} aria-hidden="true" /> Voting Locked</span>}
            </div>
            {deadline && (
                <div className={styles.description} style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-1-5)' }}>
                    <Clock size={14} aria-hidden="true" /> Prediction deadline: <strong>{formatDateTime(deadline)}</strong>
                </div>
            )}
            {content.settings?.description && content.settings?.descText && (
                <div className={styles.description}>{content.settings.descText}</div>
            )}
            {options.map((opt) => {
                const id = opt.id || opt;
                const label = opt.label || opt;
                return (
                    <button
                        key={id}
                        className={`${styles.option} ${selected === id ? styles.selected : ''}`}
                        onClick={() => !isDisabled && setSelected(id)}
                        disabled={isDisabled}
                    >
                        <span className={`${styles.indicator} ${styles.radio} ${selected === id ? styles.checked : ''}`}>
                            {selected === id && '✓'}
                        </span>
                        {label}
                    </button>
                );
            })}
            <button className={styles.submitBtn} onClick={handleSubmit} disabled={submitDisabled}>
                {submitLabel}
            </button>
        </div>
    );
};

export default PredictionForm;
